import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { IMAGES } from '../data/landing';
import { useOfferCountdown } from '../utils/useOfferCountdown';
export function Hero() {
  const countdown = useOfferCountdown();
  return <section className="relative w-full overflow-hidden bg-[#0d1f36] pt-9 text-white sm:pt-10" data-id="element-97" data-mp="4mruz2uyk3ma">
      <div className="fixed inset-x-0 top-0 z-[60] flex min-h-9 items-center justify-center bg-red-600 px-3 py-1.5 text-center text-[10px] font-bold uppercase tracking-wide text-white shadow-md sm:min-h-10 sm:text-sm" data-id="element-98" data-mp="128frdnreylxt">
        <span className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5" data-id="element-99" data-mp="s9q75oc1opee">
          <span data-id="element-100" data-mp="nbexbdlr2ew6">🔥 Oferta 63% OFF termina en</span>
          <span aria-live="polite" className="rounded bg-[#0d1f36] px-2 py-0.5 font-black tabular-nums text-yellow-300" data-id="element-101" data-mp="3d1ik78o21amw">
            {countdown}
          </span>
        </span>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.55
    }} className="mx-auto max-w-5xl px-4 pb-3 pt-8 text-center sm:px-6 sm:pt-12" data-id="element-102" data-mp="384s78u7jqv5p">
        <div className="mb-4 flex flex-wrap items-center justify-center gap-2" data-id="element-103" data-mp="39auqrc9b5kwp">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-3 py-1 text-xs font-black uppercase text-[#0d1f36]" data-id="element-104" data-mp="3e9fs5f0aqamq">
            <FlameIcon className="h-3.5 w-3.5" data-id="element-105" data-mp="30gzteqefgyrm" /> Air Fryer Argentina
          </span>
        </div>
        <h1 className="text-3xl font-black leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-106" data-mp="359syjfdt6948">
          Dejá de tirar <span className="text-red-400" data-id="element-107" data-mp="2qlenwia5hgd4">$15.000 por noche</span> en delivery frío. Aprendé el secreto para comer como en un{' '}
          <span className="text-yellow-400" data-id="element-108" data-mp="2vgllr9gqnqu4">BODEGÓN</span> en 15 min y por menos de lo que sale un alfajor.
        </h1>
        <p className="mx-auto mt-5 max-w-3xl text-base leading-relaxed text-slate-200 sm:text-lg" data-id="element-109" data-mp="2lkimqch6o8be">
          El sistema definitivo de <span className="font-bold text-white" data-id="element-110" data-mp="s2bc6ahwz5ay">250 recetas</span> diseñado para el bolsillo argentino. Dominá tu Air Fryer, ahorrá el{' '}
          <span className="font-bold text-yellow-300" data-id="element-111" data-mp="na060pwkyn9y">50% en el súper</span> y olvidate de lavar ollas para siempre.
        </p>
      </motion.div>

      <div className="mx-auto grid max-w-6xl items-center gap-7 px-4 pb-9 pt-4 sm:px-6 lg:grid-cols-[1.08fr_.92fr] lg:gap-10 lg:pb-12" data-id="element-112" data-mp="ddnf1zsf6niw">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.08
      }} className="order-1" data-id="element-113" data-mp="1b0dte347zxy7">
          <img src={IMAGES.mockupPrincipal} alt="MegaPack Air Fryer Argentina: 4 tomos de recetas y 5 bonos" className="mx-auto w-full max-w-xl drop-shadow-2xl" data-id="element-114" data-mp="110wovp0pfq3t" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.16
      }} className="order-2 rounded-3xl border border-white/10 bg-white/5 p-5 shadow-2xl sm:p-7" data-id="element-115" data-mp="3hrd9yx6dbe0y">
          <CtaButton large showPrice={false} subtitle="Acceso inmediato por solo $14.900" data-id="element-116" data-mp="21b63txn6x0mn" />
          <div className="mt-5 flex items-center justify-center gap-2 rounded-xl border border-yellow-400/30 bg-[#102946] px-4 py-3 text-center text-sm font-bold text-yellow-100" data-id="element-117" data-mp="2b0fvjce4gha8">
            <span className="flex items-center gap-1 text-yellow-400" aria-label="Calificación 4.9 de 5 estrellas" data-id="element-118" data-mp="2g2584wgzt30f">
              <StarIcon className="h-4 w-4 fill-current" data-id="element-119" data-mp="2p0qnkir641wz" /> 4.9/5
            </span>
            <span className="text-slate-400" data-id="element-120" data-mp="2oyo1g9t4ysxj">—</span>
            <span data-id="element-121" data-mp="2tyino01yuuc9">Más de 12.400 familias argentinas cocinando hoy</span>
          </div>
        </motion.div>
      </div>

      <div className="relative w-full" data-id="element-122" data-mp="uo0we8s6p6ta">
        <img src={IMAGES.heroFood} alt="Plato abundante estilo bodegón argentino cocinado en Air Fryer" className="h-48 w-full object-cover sm:h-72 lg:h-80" data-id="element-123" data-mp="zlara3yceaoi" />
        <div className="absolute inset-0 flex items-end bg-gradient-to-t from-[#0d1f36] via-[#0d1f36]/25 to-transparent" data-id="element-124" data-mp="3vhp1rn2btul8">
          <p className="mx-auto max-w-3xl px-4 pb-5 text-center text-base font-bold text-white sm:text-xl" data-id="element-125" data-mp="e9tphn8vfr08">
            Milanesas crocantes, pollo dorado y empanadas de bodegón… sin freidora de aceite y sin ensuciar la cocina.
          </p>
        </div>
      </div>
    </section>;
}